import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from '../../_services/config.service';
import { CmpConversation, CmpMessage, ChatUser } from '../_models/messaging.model';

@Injectable({
	providedIn: 'root',
})
export class MessagingService {
	constructor(
		private http: HttpClient,
		private configService: ConfigService,
	) {}

	private get baseUrl(): string {
		return this.configService.companiesUrl;
	}

	// --- Conversazioni ---

	getConversations(): Observable<CmpConversation[]> {
		return this.http.get(`${this.baseUrl}messaging/conversations`, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	findOrCreateConversation(otherUsrId: number): Observable<CmpConversation> {
		return this.http
			.post(`${this.baseUrl}messaging/conversations/find-or-create`, { other_usr_id: otherUsrId }, { observe: 'response' })
			.pipe(map((r: any) => r.body));
	}

	// --- Messaggi ---

	getMessages(convId: number): Observable<CmpMessage[]> {
		return this.http.get(`${this.baseUrl}messaging/messages/${convId}`, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	sendMessage(convId: number, text: string): Observable<CmpMessage> {
		const formData = new FormData();
		formData.append('text', text);
		return this.http.post(`${this.baseUrl}messaging/messages/send/${convId}`, formData, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	markAsRead(convId: number): Observable<number> {
		return this.http.put(`${this.baseUrl}messaging/messages/read/${convId}`, {}, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	getUnreadCount(): Observable<number> {
		return this.http.get(`${this.baseUrl}messaging/unread-count`, { observe: 'response' }).pipe(map((r: any) => r.body));
	}

	// --- Utenti ---

	searchUsers(txtsearch: string = ''): Observable<ChatUser[]> {
		return this.http
			.get(`${this.baseUrl}messaging/users?txtsearch=${encodeURIComponent(txtsearch)}`, { observe: 'response' })
			.pipe(map((r: any) => r.body));
	}
}
